import styled from "styled-components";
import FlexBox from "../../layout/boxes/FlexBox/FlexBox";
import { ListProps } from "./List.types";

const StyledList = styled(FlexBox)<ListProps>`
	list-style-type: none;

	// Projects really need to start using the AppContainer, which provides application
	// level resets. When used, the following isn't needed. But for now we will leave this in...
	padding-inline-start: ${({ theme, padding, paddingLeft }) => {
		const PADDING = padding || paddingLeft;
		return PADDING ? theme.space[PADDING] : 0;
	}};

	${({ theme, columnGap, rowGap }) => {
		return {
			gap: `${rowGap === "expanded" ? theme.space.lg : 0}
        ${columnGap === "expanded" ? theme.space.lg : 0}`,
			borderRadius: theme.radii.xs,
		};
	}}
`;

export default StyledList;
